import React, { useState } from 'react';
import { Segmented } from 'antd';

/**
 * Présente une annonce dans les proportions usuelles des placements Meta. Cet aperçu
 * est indicatif : Meta peut adapter le cadrage final selon l'inventaire disponible.
 *
 * @param {object} ad - Textes, visuel et bouton de l'annonce à représenter
 */
const MetaAdsPlacementPreview = ({ ad }) => {
  const [placement, setPlacement] = useState('facebook');
  const vertical = ['story', 'reels'].includes(placement);
  const labels = { facebook: 'Facebook', instagram: 'Instagram', story: 'Story', reels: 'Reels' };

  return (
    <div className="space-y-3">
      <Segmented
        block
        value={placement}
        onChange={setPlacement}
        options={Object.entries(labels).map(([value, label]) => ({ value, label }))}
      />
      <div className={`mx-auto border rounded-lg overflow-hidden bg-white shadow-sm ${vertical ? 'max-w-[250px]' : 'max-w-[380px]'}`}>
        <div className="p-3 flex items-center gap-2 text-xs">
          <div className="w-7 h-7 rounded-full bg-blue-600" data-ui-preserve-color={true /* Conserve le repère métier, graphique ou de marque. */} />
          <div><strong>Votre boutique</strong><br /><span className="text-gray-500">Sponsorisé · {labels[placement]}</span></div>
        </div>
        {ad.format === 'slideshow' ? (
          <div className="relative bg-black aspect-[4/5] overflow-hidden">
            {(ad.slideshowImages || []).slice(0, 1).map((imageUrl, index) => (
              imageUrl ? <img key={index} src={imageUrl} alt={ad.headline} className="w-full h-full object-cover" /> : null
            ))}
            <span className="absolute bottom-2 left-2 rounded bg-black/70 px-2 py-1 text-white text-xs">▶ Slideshow vidéo · {(ad.slideshowImages || []).length} images</span>
          </div>
        ) : ad.format === 'carousel' ? (
          <div className="flex gap-2 overflow-hidden p-2 bg-gray-100">
            {(ad.carouselCards || []).map((card, index) => (
              <div key={index} className="shrink-0 w-3/4 bg-white border rounded overflow-hidden">
                {card.imageUrl ? <img src={card.imageUrl} alt={card.headline} className="w-full aspect-square object-cover" /> : <div className="bg-gray-200 aspect-square" />}
                <div className="p-2"><strong className="block truncate">{card.headline}</strong><span className="text-gray-500 line-clamp-2">{card.description}</span></div>
              </div>
            ))}
          </div>
        ) : ad.imageUrl ? (
          <img src={ad.imageUrl} alt={ad.headline} className={`w-full object-cover ${vertical ? 'aspect-[9/16]' : 'aspect-square'}`} />
        ) : <div className={`bg-gray-200 ${vertical ? 'aspect-[9/16]' : 'aspect-square'}`} />}
        <div className="p-3 text-xs">
          {!vertical && <p className="mb-2 whitespace-pre-line">{ad.primaryText}</p>}
          <div className="flex justify-between items-center gap-2 bg-gray-50 p-2">
            <div className="min-w-0"><strong className="block truncate">{ad.headline}</strong><span className="text-gray-500">{ad.description}</span></div>
            <span className="shrink-0 rounded bg-gray-200 px-2 py-1 font-medium">{ad.callToAction}</span>
          </div>
        </div>
      </div>
      {vertical && <p className="text-xs text-gray-500">Les Stories et Reels utilisent un format vertical 9:16. Vérifiez que le sujet principal reste visible.</p>}
    </div>
  );
};

export default MetaAdsPlacementPreview;
